import { mockAuthoritiesItems, mockAuthoritiesSummary } from '@/__mocks__';

const authoritiesApi = {
  requestList() {
    return new Promise((resolve) => {
      const authorities = 10;
      setTimeout(() => {
        const items = {
          data: {
            authorities: mockAuthoritiesItems(authorities),
            paging: {
              next_cursor: 'MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              next_link:
                'https://localhost/items?cursor=MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              total_count: authorities,
            },
          },
        };
        resolve(items);
      }, 100);
    });
  },
  requestSummary() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const summary = { data: mockAuthoritiesSummary() };
        resolve(summary);
      }, 100);
    });
  },
};

export default authoritiesApi;
